import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import SettingsContainer from '../../../components/settings-container';
import MultiSelect from '../../../components/multi-select';
import { saveMultiFitnessGoals } from '../../../store/ducks/user';

const selectOptions = [
  {
    optionText: 'Lose weight',
    optionValue: 'weightloss',
  },
  {
    optionText: 'Improve muscle tone',
    optionValue: 'leanandtone',
  },
  {
    optionText: 'Improve performance',
    optionValue: 'strengthandpower',
  },
  {
    optionText: 'Improve health and wellness',
    optionValue: 'healthandwellness',
  },
  {
    optionText: 'Maintain',
    optionValue: 'happyandhealthy',
  }
];

export class PureMultiFitnessGoalPage extends Component {
  constructor(props) {
    super(props);

    this.state = { multipleFitnessGoals: props.initialValue };
  }

  save = async () => {
    try {
      await this.props.saveMultipleGoals(this.state.multipleFitnessGoals);
    } catch (e) {
      /* do nothing */
    }
  }

  getActiveOptions = () => {
    return this.state.multipleFitnessGoals.map((fitnessGoal) => {
      return selectOptions.findIndex(option => option.optionValue === fitnessGoal);
    });
  }

  setGoals = (activeOptions) => {
    let multipleFitnessGoals = [];
    activeOptions.forEach((index) => {
      multipleFitnessGoals = multipleFitnessGoals.concat(selectOptions[index].optionValue);
    });

    this.setState({ multipleFitnessGoals });
  }

  render() {
    return (
      <SettingsContainer
        className="multi-fitness-goal-page"
        pageTitle="What are your goals?"
        save={ this.save }
        subtitle
        isValid={ Boolean(this.state.multipleFitnessGoals.length) }
      >
        <MultiSelect
          selectOptions={ selectOptions }
          initialValue={ this.getActiveOptions() }
          setActiveOptions={ this.setGoals }
        />
      </SettingsContainer>
    );
  }
}

PureMultiFitnessGoalPage.propTypes = {
  initialValue: PropTypes.array.isRequired,
  saveMultipleGoals: PropTypes.func.isRequired,
};

PureMultiFitnessGoalPage.defaultProps = {
  initialValue: []
};

export default connect(
  state => ({
    initialValue: state.user.multiple_fitness_goals || [],
  }),
  dispatch => ({
    saveMultipleGoals: multipleFitnessGoals => dispatch(saveMultiFitnessGoals(multipleFitnessGoals))
  }),
  null,
  { withRef: true }
)(PureMultiFitnessGoalPage);
